<template>
  <div>
    <div class="d-flex align-items-center justify-content-end mt-3 mb-4">
      <div class="d-flex">
        <b-dropdown variant="secondary">
          <template slot="button-content">
            報名審核
          </template>
          <b-dropdown-item @click="approved">
            審核通過
          </b-dropdown-item>
          <b-dropdown-item @click="rejected">
            審核不通過
          </b-dropdown-item>
          <b-dropdown-item @click="resetToPending">
            重設為待審核
          </b-dropdown-item>
        </b-dropdown>
        <div class="ml-2 mr-2">
          <b-dropdown variant="secondary">
            <template slot="button-content">
              報到設定
            </template>
            <b-dropdown-item
              v-for="item in checkinStatusOptions"
              :key="item.value"
              @click="setCheckinResult(item.value)"
            >
              {{ item.text }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="d-flex align-items-center border-0">
          <b-dropdown
            class="flex-shrink-0"
            variant="inverse-primary"
          >
            <template #button-content>
              <span class="mdi mdi-file-excel mr-1"></span> 匯出excel
            </template>
            <b-dropdown-item @click="handleExport(0)">匯出報名資料</b-dropdown-item>
            <b-dropdown-item @click="handleExport(1)">匯出報名與填寫資料</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="ml-2" v-if="canImportRegistrations">
          <b-button
            class="flex-shrink-0"
            variant="inverse-primary"
            @click="showImportModal = true"
          >
            <span class="mdi mdi-upload mr-1"></span>
            匯入報名資料
          </b-button>
        </div>
<!--        <b-button-->
<!--          variant="inverse-primary"-->
<!--          class="text-nowrap"-->
<!--          @click="handleExport"-->
<!--        >-->
<!--          <span class="mdi mdi-file-excel mr-1"></span>-->
<!--          匯出 Excel-->
<!--        </b-button>-->
      </div>
      <b-input-group class="ml-4" style="width: 200px">
        <b-form-select
          v-model="query.status"
          :options="statusOptions"
          @change="handlePageReset"
        >
          <template #first>
            <b-form-select-option :value="null">選擇審核狀態</b-form-select-option>
          </template>
        </b-form-select>
      </b-input-group>
      <b-input-group class="ml-4" style="width: 200px">
        <b-form-select
          v-model="query.checkin_status"
          :options="checkinStatusOptions"
          @change="handlePageReset"
        >
          <template #first>
            <b-form-select-option :value="null">選擇報到狀態</b-form-select-option>
          </template>
        </b-form-select>
      </b-input-group>
      <b-button
        v-b-toggle.collapse-1-inner
        variant="link"
        class="flex-shrink-0 ml-0 ml-xl-1"
      >
        進階搜尋<i class="fa fa-chevron-down"></i>
      </b-button>
    </div>

    <b-collapse id="collapse-1-inner" class="mt-2">
      <div class="border p-2">
        <b-form class="">
          <div class="d-flex flex-column flex-xl-row flex-wrap">
            <b-form-group
              label="填寫內容"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <b-form-input
                class="mr-3"
                v-model="query.res_keyword"
                placeholder="搜尋填寫內容"
                :disabled="loading"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <template #label>
                <div style="line-height: 1.2;">
                  會員名稱<br>(顯示名稱)
                </div>
              </template>
              <b-form-input
                class="mr-3"
                v-model="query.customer_name"
                placeholder="搜尋會員名稱(顯示名稱)"
                :disabled="loading"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="會員編號"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <b-form-input
                class="mr-3"
                v-model="query.customer_outer_code"
                placeholder="搜尋會員編號"
                :disabled="loading"
              ></b-form-input>
            </b-form-group>
            <!-- Dynamic customer profile fields -->
            <b-form-group
              v-for="field in dynamicCustomerFields"
              :key="field.key"
              :label="field.label"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <b-form-input
                class="mr-3"
                v-model="query[field.queryKey]"
                :placeholder="`搜尋${field.label}`"
                :disabled="loading"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="flex-column">
            <b-button
              variant="primary"
              class="mb-2 mb-xl-0 mr-2"
              @click="resetSearch"
            >
              <i class="mdi mdi-restart"></i> 重置搜尋條件
            </b-button>
            <b-button
              variant="primary"
              class="mb-2 mb-xl-0"
              @click="handlePageReset"
            >
              <i class="fa fa-search"></i> 搜尋
            </b-button>
          </div>
        </b-form>
      </div>
    </b-collapse>

    <b-table
      responsive
      striped
      hover
      :items="results"
      :fields="fields"
      @sort-changed="handleSort"
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #head(checkbox)>
        <b-form-checkbox
          v-model="selectAll"
          @change="toggleSelectAll"
        ></b-form-checkbox>
      </template>
      <template #cell(checkbox)="data">
        <b-form-checkbox
          v-model="data.item.selected"
        ></b-form-checkbox>
      </template>
      <template #cell(avatar_url)="data">
        <router-link
          v-if="data.item.source === 'liff'"
          :to="{ name: 'CustomerDetailView', params: { customerID: data.item.customer.id } }"
        >
          <b-avatar
            :src="data.item.customer.avatar_url"
            variant="secondary"
            size="2rem"
          ></b-avatar>
        </router-link>
        <b-avatar
          v-else
          :src="data.item.customer.avatar_url"
          variant="secondary"
          size="2rem"
        ></b-avatar>
      </template>
      <template #cell(customer_name)="data">
        <router-link
          v-if="data.item.source === 'liff'"
          :to="{ name: 'CustomerDetailView', params: { customerID: data.item.customer.id } }"
        >
          {{ data.item.customer.name }}
        </router-link>
        <span v-else>
          {{ data.item.customer.name }}
        </span>
      </template>
      <template #cell(created_at)="data">
        {{ formatDate(data.item.created_at) }}
      </template>
      <template #cell(status)="data">
        {{ statusForDisplay[data.item.status] }}
      </template>
      <template #cell(status_at)="data">
        {{ formatDate(data.item.status_at) }}
      </template>
      <template #cell()="data">
        <TableCell
          v-if="data.value !== undefined"
          :content="data.value"
          :title="fields.find(f => f.key === data.field.key).label"
        />
      </template>
    </b-table>
    <CustomPagination
      :currentPage="query.page"
      :totalRows="totalRows"
      :perPage="query.per_page"
      @page-change="handlePageChange"
      @per-page-change="handlePerPageChange"
    />

    <!-- Import Modal -->
    <b-modal
      v-model="showImportModal"
      title="匯入報名資料"
      @ok="handleImport"
      :ok-disabled="!importFile"
      ok-title="匯入"
      cancel-title="取消"
    >
      <b-form-group label="選擇 Excel 檔案">
        <b-form-file
          v-model="importFile"
          accept=".xlsx,.xls,.csv"
          placeholder="請選擇檔案..."
          drop-placeholder="拖拽檔案到此處"
        ></b-form-file>
      </b-form-group>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="
            getSampleExcelFile(
              deepGet(getModule('form'), 'module_config.event.event_customer_import_xls', '/excel/event_registration_sample.xlsx'),
              '/excel/event_registration_sample.xlsx'
            )
          "
          ><i class="fa fa-file-text"></i>下載範例檔案</b-button
        >
        <b-button variant="secondary" @click="cancel">取消</b-button>
        <b-button variant="primary" :disabled="!importFile" @click="ok">匯入</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import formApi from "@/apis/form";
import { updateQueryFromRoute, updateUrlWithoutReload } from "@/utils/updateUrl";
import _ from "lodash";
import deepGet from "lodash/get";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import * as consts from "@/consts";
import TableCell from "@/components/Dashboard/FormResult/TableCell.vue";
import { getSampleExcelFile } from "@/utils/dashboardUtils";

const initialQuery = {
  page: 1,
  per_page: 10,
  res_keyword: "",
  customer_name: "",
  customer_outer_code: "",
  sort_by: "created_at",
  order_by: "desc",
  checkin_status: null,
  status: null,
  export_type: 0
};

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.init();
        }
      }
    }
  },
  components: {
    CustomPagination,
    TableCell,
  },
  data() {
    return {
      totalRows: 0,
      selectAll: false,
      loading: false,
      showImportModal: false,
      importFile: null,
      fields: [],
      defaultFields: [
        {
          key: "checkbox",
        },
        {
          key: "avatar_url",
          label: "",
          sortable: false,
        },
        {
          key: "customer_name",
          label: "顯示名稱",
          sortable: false,
        },
        {
          key: "created_at",
          label: "填寫日期",
          sortable: true,
        },
        {
          key: "status",
          label: "審核狀態",
          sortable: true,
        },
        {
          key: "status_at",
          label: "審核更新時間",
          sortable: true,
        },
        {
          key: "checkin_status",
          label: "報到狀態",
          formatter: (value) => {
            return this.checkinStatusOptions.find((cso) => {
              return cso.value === value;
            })?.text ?? "";
          },
          sortable: true,
        },
        {
          key: "checkin_status_at",
          label: "報到更新時間",
          sortable: true,
        },
      ],
      results: [],
      form: {
        subjects: [],
      },
      query: { ...initialQuery },
      checkinStatusOptions: [
        { value: "attended", text: "已報到" },
        { value: "expired", text: "逾期報到" },
        { value: "canceled", text: "取消報到" },
        { value: "no-show", text: "逾期未到" },
        { value: "reset-checkin", text: "清除報到狀態" },
      ],
      statusOptions: [
        { value: "pending", text: "待審核" },
        { value: "approved", text: "審核通過" },
        { value: "rejected", text: "審核不通過" },
        { value: "auto-approved", text: "自動審核" },
      ],
    }
  },
  computed: {
    ...mapGetters('dashboardModule', ["getModule"]),
    ...mapState('general', ['organization']),

    dynamicCustomerFields() {
      return this.fields
        .filter(field => field.key && field.key.startsWith('customer.profiles.'))
        .map(field => ({
          key: field.key,
          label: field.label,
          queryKey: `customer_profile_${field.key.replace('customer.profiles.', '')}`
        }));
    },
    statusForDisplay() {
      return {
        null: '',
        approved: '審核通過',
        rejected: '審核不通過',
        pending: '待審核',
        'auto-approved': '自動審核',
      }
    },
    canImportRegistrations() {
      // Check if form has both name and phone fields with proper assign_to_customer_data and manual checkin is enabled
      if (!this.form || !this.form.subjects) return false;

      const hasNameField = this.form.subjects.some(subject =>
        subject.config?.assign_to_customer_data === 'extra.name'
      );
      const hasPhoneField = this.form.subjects.some(subject =>
        subject.config?.assign_to_customer_data === 'mobile_phone'
      );
      const isManualCheckinEnabled = this.form.config?.event_setting?.enable_manual_checkin ?? false;

      return hasNameField && hasPhoneField && isManualCheckinEnabled;
    },
    autoFilledSubjectIds() {
      if (!this.form || !this.form.subjects) return [];

      return this.form.subjects
        .filter((subject) => {
          const assignTo = subject.config?.assign_to_customer_data;
          return assignTo === 'extra.name' || assignTo === 'mobile_phone';
        })
        .map(subject => subject.id);
    },
  },
  methods: {
    getSampleExcelFile,
    deepGet: _.get,
    ...mapActions('dashboardModule', ['fetchModule']),
    async setCheckinResult(value) {
      let payload = {};
      payload.type = value;
      payload.result_ids = this.results
        .filter((item) => item.selected)
        .map((item) => item.id);
      if (payload.result_ids.length == 0) {
        this.$swal.fire({
          title: "變更失敗",
          type: "warning",
          text: "至少請勾選一名對象",
        });
        return
      }
      try {
        await formApi.checkinResults(
          this.$route.params.id,
          payload
        );
        this.$swal.fire({
          title: "成功",
          type: "success",
          text: "更新成功",
        });
        this.fetchResults();
      } catch (error) {
        console.error(error);
        if (error.status !== 401) {
          this.$swal.fire({
            title: "更新失敗",
            type: "error",
            text: error.response.data.message,
          });
        }
      }
    },
    async approved() {
      let payload = {};
      payload.result_ids = this.results
        .filter((item) => item.selected)
        .map((item) => item.id);
      if (payload.result_ids.length == 0) {
        this.$swal.fire({
          title: "審核失敗",
          type: "warning",
          text: "至少請勾選一名對象",
        });
        return
      }
      try {
        await formApi.verifyFormApproved(
          this.$route.params.id,
          payload
        );
        this.$swal.fire({
          title: "成功",
          type: "success",
          text: "變更成功",
        });
        this.fetchResults();
      } catch (error) {
        if (error.status !== 401) {
          this.$swal.fire({
            title: "更新失敗",
            type: "error",
            text: error.response.data.message,
          });
        }
      }
    },
    async rejected() {
      let payload = {};
      payload.result_ids = this.results
        .filter((item) => item.selected)
        .map((item) => item.id);
      if (payload.result_ids.length == 0) {
        this.$swal.fire({
          title: "審核失敗",
          type: "warning",
          text: "至少請勾選一名對象",
        });
        return
      }
      try {
        await formApi.verifyFormRejected(
          this.$route.params.id,
          payload
        );
        this.$swal.fire({
          title: "成功",
          type: "success",
          text: "變更成功",
        });
        this.fetchResults();
      } catch (error) {
        if (error.status !== 401) {
          this.$swal.fire({
            title: "更新失敗",
            type: "error",
            text: error.response.data.message,
          });
        }
      }
    },
    async resetToPending() {
      let payload = {};
      payload.result_ids = this.results
        .filter((item) => item.selected)
        .map((item) => item.id);
      if (payload.result_ids.length == 0) {
        this.$swal.fire({
          title: "重設失敗",
          type: "warning",
          text: "至少請勾選一名對象",
        });
        return
      }
      try {
        await formApi.resetResultsToPending(
          this.$route.params.id,
          payload
        );
        this.$swal.fire({
          title: "成功",
          type: "success",
          text: "重設成功",
        });
        this.fetchResults();
      } catch (error) {
        if (error.status !== 401) {
          this.$swal.fire({
            title: "重設失敗",
            type: "error",
            text: error.response.data.message,
          });
        }
      }
    },
    toggleSelectAll() {
      this.results.forEach((item) => (item.selected = this.selectAll));
    },
    async fetchResults () {
      this.selectAll = false;
      try {
        this.fields = [...this.defaultFields];

        const response = await formApi.getResults(this.$route.params.id, this.query);
        this.results = response.data.data.map((item) => {
          return {
            ...item,
            selected: false,
          };
        });
        this.totalRows = response.data.meta.total;
        this.form = response.data.form;

        // 插入在 config 額外設定的 customer 相關欄位
        await this.fetchModule({ code: 'customer', org_id: this.organization.id })
        const profileMappings = deepGet(this.getModule("customer"), 'module_config.event.customer_list', [])
          .find(fieldMappingConfig => fieldMappingConfig.merchant_type === consts.MERCHANT_TYPES.LINE_TYPE);

        let extraColumns = deepGet(profileMappings, 'member_fields', [])
          .map((mapping) => {
            if (mapping.matched_key.startsWith("extra.")) {
              const key = mapping.matched_key.split("extra.")[1];
              return {
                key: `customer.profiles.${key}`,
                label: mapping.title,
              };
            } else {
              return {
                key: `customer.${mapping.matched_key}`,
                label: mapping.title,
              };
            }
          });

        // 拿出form模組，判斷是否需要塞入額外欄位 name & phone
        await this.fetchModule({ code: 'form', org_id: this.organization.id })
        let showSubjects = deepGet(this.getModule("form"), 'module_config.showresult_in_event_registration', false);
        let showCustomerData = deepGet(this.getModule("form"), 'module_config.show_customer_data_in_event_registration', false);

        let subjects = [];
        if (showSubjects) {
          subjects = this.form.subjects.map((subject) => {
            return {
              key: subject.id,
              label: subject.config.title ?? '無標題',
            };
          })
        }

        const autoFilledSubjects = (this.canImportRegistrations && showCustomerData)
          ? this.form.subjects
            .filter((subject) => this.autoFilledSubjectIds.includes(subject.id))
            .map((subject) => ({
              key: subject.id,
              label: subject.config.title ?? '無標題',
            }))
          : [];

        const filteredSubjects = subjects.filter(
          (subject) => !this.autoFilledSubjectIds.includes(subject.key)
        );

        this.fields = [
          ...this.fields.slice(0, 3),
          ...extraColumns,
          ...autoFilledSubjects,
          ...filteredSubjects,
          ...this.fields.slice(3),
        ];

        // 把 results.responses 依照 subjects 攤開
        for (let i = 0; i < this.results.length; i ++) {
          let result = this.results[i];
          for (let j = 0; j < result.responses.length; j ++) {
            let response = result.responses[j];
            // 如果 response.value 是陣列，就轉成字串
            if (Array.isArray(response.value)) {
              response.value = response.value.join(', ');
            }
            this.results[i][response.subject_id] = response.value;
          }
        }
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取表單結果錯誤", "error");
      }
    },
    async init() {
      this.loading = true
      this.query = updateQueryFromRoute(
        this.$route,
        this.$store,
        this.query,
      );
      await this.fetchResults();
      this.loading = false
    },
    async reset() {
      this.loading = true
      this.$set(this, 'query', { ...initialQuery });
      await this.fetchResults();
      this.loading = false
    },
    async runQueryAndUpdateUrl() {
      this.loading = true
      updateUrlWithoutReload(this.query, this.$store, this.$router);
      await this.fetchResults();
      this.loading = false
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm");
      }
    },
    handleSort(ctx) {
      this.query.sort_by = ctx.sortBy;
      this.query.order_by = ctx.sortDesc ? "desc" : "asc";
      this.handlePageReset();
    },
    handlePageChange(newPage) {
      this.query.page = newPage;
      this.runQueryAndUpdateUrl();
    },
    handlePerPageChange(newPerPage) {
      this.query.per_page = newPerPage;
      this.query.page = 1;
      this.runQueryAndUpdateUrl();
    },
    async handlePageReset() {
      this.loading = true
      const currentPage = parseInt(this.query.page, 10);

      if (currentPage === 1) {
        updateUrlWithoutReload(this.query, this.$store, this.$router);
      } else {
        this.query.page = 1;
      }

      await this.fetchResults();
      this.loading = false
    },
    async resetSearch() {
      this.loading = true;
      // Reset all search fields but preserve status filters and pagination settings
      const resetQuery = {
        ...initialQuery,
        per_page: this.query.per_page,
        status: this.query.status,
        checkin_status: this.query.checkin_status
      };
      // Reset dynamic customer profile fields
      this.dynamicCustomerFields.forEach(field => {
        resetQuery[field.queryKey] = "";
      });
      this.$set(this, 'query', resetQuery);
      await this.fetchResults();
      this.loading = false;
    },
    handleExport(type) {
      this.query.export_type = type;
      formApi.exportEventRegistrations(this.form.id, this.query).then(() => {
        this.$swal({
          title: "成功",
          text: "可至“我的主控台”查看紀錄及下載檔案",
          showCancelButton: true,
          cancelButtonText: '確認',
          type: "success",
          confirmButtonText: "前往查看",
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "MyConsoleDownloadFileList",
              params: { org_code: this.$route.params.org_code },
            });
          }
        });
      });
    },
    async handleImport() {
      if (!this.importFile) return;

      const formData = new FormData();
      formData.append('file', this.importFile);

      try {
        const response = await formApi.importResults(this.form.id, formData);

        if (response.data.status === 'success') {
          const { created, existed } = response.data.data;
          const lines = `<span>新增 ${created} 筆</span><br><span>${existed} 筆已存在，不重複匯入</span>`;
          this.$swal({
            title: "匯入成功",
            html: lines,
            type: "success",
          });
          this.fetchResults(); // Refresh the list
        } else {
          this.$swal({
            title: "匯入失敗",
            text: response.data.message,
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "匯入失敗",
          text: error.response?.data?.message || "發生未知錯誤",
          type: "error",
        });
      } finally {
        this.showImportModal = false;
        this.importFile = null;
      }
    }
  },
}
</script>
